import React from "react";
import { PRODUCTS } from "../product";
import leafImage from "../assets/footer_left_lettuce.png";
import chiliImage from "../assets/red_chili_pepper.png";

const ClocheIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-[#f25e1c]">
    <path d="M3 18h18" />
    <path d="M12 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" />
    <path d="M5 18a7 7 0 0 1 14 0H5Z" />
  </svg>
);

const PopularFoodItems = () => {
  return (
    <section className="relative bg-[#faf8f5] py-24 px-6 overflow-hidden select-none">
      {/* Self-contained animations for rotating dotted borders */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes rotate-dotted {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .animate-rotate-dotted {
          animation: rotate-dotted 15s infinite linear;
        }
      `,
        }}
      />

      {/* Decorative leaf background (bottom left) */}
      <div className="absolute left-0 bottom-0 w-36 md:w-52 opacity-95 pointer-events-none select-none z-0">
        <img
          src={leafImage}
          alt="Arugula leaf decoration"
          className="w-full h-auto object-contain origin-bottom-left mix-blend-multiply"
        />
      </div>

      {/* Decorative red chili background (top right) */}
      <div className="absolute right-0 top-4 w-40 md:w-60 opacity-95 pointer-events-none select-none z-0">
        <img
          src={chiliImage}
          alt="Chili pepper decoration"
          className="w-full h-auto object-contain origin-top-right mix-blend-multiply"
        />
      </div>

      {/* Main Container */}
      <div className="max-w-6xl mx-auto relative z-10">
        
        {/* Section Header */}
        <div className="text-center mb-16 flex flex-col items-center">
          <div className="inline-flex items-center gap-2 px-4 py-1">
            <ClocheIcon />
            <span className="text-[#f25e1c] font-black tracking-widest text-[11px] uppercase font-mono">
              BEST FOOD
            </span>
            <ClocheIcon />
          </div>
          
          <h2 className="text-3xl md:text-[40px] font-black text-[#0f172a] mt-2 tracking-tight font-sans">
            Popular Food Items
          </h2>
        </div>

        {/* Responsive Product Grid with shifted vertical alignment for overlapping effect */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-24 mt-28 justify-items-center">
          {PRODUCTS.map((product) => (
            <div
              key={product.id}
              className="relative flex flex-col items-center w-full max-w-[220px]"
            >
              
              {/* Overlapping Food Circle (centered, shifted up by half its height) */}
              <div className="absolute top-[-70px] w-36 h-36 flex items-center justify-center z-20">
                {/* Red Dotted Rotating Border */}
                <div className="absolute inset-0 rounded-full border-2 border-dotted border-[#e21b1b] animate-rotate-dotted pointer-events-none" />
                
                {/* Image Container with spacer inside the dotted border */}
                <div className="w-[90%] h-[90%] rounded-full overflow-hidden flex items-center justify-center bg-white shadow-md border border-neutral-100/50 p-1">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full rounded-full object-cover bg-transparent"
                  />
                </div>
              </div>

              {/* White Card container box */}
              <div className="bg-white rounded-[20px] shadow-[0_8px_30px_rgba(0,0,0,0.02)] border border-neutral-100/70 pt-20 pb-8 px-5 flex flex-col items-center justify-center text-center w-full relative z-10 transition-all duration-300 hover:shadow-[0_15px_35px_rgba(0,0,0,0.05)]">
                {/* Product Title */}
                <h3 className="text-[16px] font-extrabold text-[#0f172a] mb-1.5 font-sans leading-tight">
                  {product.name}
                </h3>

                {/* Subtitle / Description */}
                <p className="text-[11px] text-slate-400 font-medium font-sans leading-normal">
                  {product.description}
                </p>

                {/* Price tag */}
                <span className="text-[16px] font-black text-[#e21b1b] mt-4 font-sans">
                  {product.price}
                </span>
              </div>

            </div>
          ))}
        </div>

        {/* View All Button at the bottom */}
        <div className="flex justify-center mt-20 z-10 relative">
          <a href="#menu" className="inline-flex items-center bg-[#e21b1b] hover:bg-[#c81616] text-white text-[11px] font-black tracking-widest uppercase pl-6 rounded transition-all duration-300 group shadow-md hover:shadow-lg select-none">
            <span>VIEW ALL ITEM</span>
            <div className="w-11 h-11 bg-white text-[#e21b1b] flex items-center justify-center ml-5 border-l border-white/10">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </div>
          </a>
        </div>

      </div>
    </section>
  );
};

export default PopularFoodItems;
